var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navbar'),_c('v-main',[_c('v-container',{class:{ 'page-fluid': _vm.isFluidPage },attrs:{"fluid":_vm.isFluidPage}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }